import ReactGA from 'react-ga';

export function sendEvent(params) {
  ReactGA.event(params);
}
